<div class="flex flex-col flex-0 py-4 px-4 border-b dark:bg-transparent">
    <div class="flex items-center">
        <mat-form-field
            class="fuse-mat-rounded fuse-mat-dense w-full"
            [subscriptSizing]="'dynamic'">
            <mat-icon
                matPrefix
                class="icon-size-5"
                [svgIcon]="'heroicons_solid:magnifying-glass'"></mat-icon>
            <input
                matInput
                [autocomplete]="'off'"
                placeholder="{{ 'Search company in tree' | transloco }}"
                (input)="filterCompanies(searchField.value)"
                #searchField>
        </mat-form-field>
        @if(shouldShowActionsMenu) {
            <button
                class="ml-2 -mr-1"
                mat-icon-button
                [matMenuTriggerFor]="companyTreeHeaderMenu">
                <mat-icon [svgIcon]="'heroicons_outline:ellipsis-vertical'"></mat-icon>
                <mat-menu #companyTreeHeaderMenu>
                    <button
                        mat-menu-item
                        [disabled]="!selectedCompany"
                        (click)="actionSelected.emit('edit')">
                        <mat-icon [svgIcon]="'heroicons_outline:document-magnifying-glass'"></mat-icon>
                        {{ 'View details' | transloco }}
                    </button>
                    <button
                        mat-menu-item
                        [disabled]="!selectedCompany"
                        (click)="actionSelected.emit('delete')">
                        <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                        {{ 'Delete company' | transloco }}
                    </button>
                </mat-menu>
            </button>
        }
    </div>
</div>

<mat-tree [dataSource]="dataSource" [treeControl]="companyTree" #tree class="doorwifi-company-tree p-3">

    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node *matTreeNodeDef="let node" class="rounded-md"
                   [class.active]="isNodeActive(node)"
                   (click)="onCompanyClick(node)"
                   [ngClass]="getNodeVisibilityClass(node)"
    >
        <div class="mat-tree-node">
            <mat-icon class="type-company-icon mr-1.5" [svgIcon]="node.getCompanyIcon()"></mat-icon>
            <div class="mat-tree-node-content" [innerHTML]="highlight(node.name)"></div>
        </div>
    </mat-tree-node>

    <!-- This is the tree node template for expandable nodes -->
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <div class="mat-tree-node rounded-md"
             [class.active]="isNodeActive(node)"
             [ngClass]="getNodeVisibilityClass(node)"
             >
            <button matTreeNodeToggle class="mat-tree-node-toggle mt-1.5">
                <mat-icon class="mat-icon-rtl-mirror">
                    {{companyTree.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </button>

            <div class="flex items-center" (click)="onCompanyClick(node)">
                <mat-icon class="type-company-icon" [svgIcon]="node.getCompanyIcon()"></mat-icon>
                <div class="mat-tree-node-content" [innerHTML]="highlight(node.name)"></div>
            </div>
        </div>

        <!-- There is inline padding applied to this div using styles.
            This padding value depends on the mat-icon-button width.  -->
        <div [class.invisible]="!companyTree.isExpanded(node)" role="group">
            <ng-container matTreeNodeOutlet></ng-container>
        </div>
    </mat-nested-tree-node>
</mat-tree>


